import { createContext, useContext } from "react";
import { PaywallState } from "./usePaywall";

const PaywallContext = createContext<PaywallState>({
  loadingPlanTier: true,
  trialing: false,
  userPlanTier: "free",
});

export function usePaywallStateDispatch() {
  return useContext(PaywallContext);
}

type Props = PaywallState & { children: any };

export function PaywallProvider({
  children,
  loadingPlanTier,
  userPlanTier,
  trialing,
}: Props) {
  return (
    <PaywallContext.Provider
      value={{
        loadingPlanTier,
        userPlanTier,
        trialing,
      }}
    >
      {children}
    </PaywallContext.Provider>
  );
}
